import ProduitEcranEnsemble from "../domain/ProduitEcranEnsemble";
import ProduitNumerique from "../domain/ProduitNumerique";
import {boomers} from "./ecran_cible/Boomers";
import {uppers} from "./ecran_cible/Uppers";
import {generationAlpha} from "./ecran_cible/GenerationAlpha";
import {workingGirls} from "./ecran_cible/WorkingGirls";

export const produitsEcransEnsemble = [
  new ProduitEcranEnsemble('cess', 'Cinessentiel', { '2025': 1190000, '2026': 1190000 } , { '2025': 166000, '2026': 200000 }),
  new ProduitEcranEnsemble('vi', 'Vision Initiale', { '2025': 2565000, '2026': 2565000 }, { '2025': 400000, '2026': 450000 }, [100, 60, 50, 33, 25]),
  new ProduitEcranEnsemble('vc', 'Vision Capitale', { '2025': 550000, '2026': 550000 }, { '2025': 105000, '2026': 110000 }, [100, 50]),
  new ProduitEcranEnsemble('ce', 'Ciné Élite', { '2025': 1900000, '2026': 1900000 }, { '2025': 375000, '2026': 375000 }, [100, 60, 50, 33, 25]),
  new ProduitEcranEnsemble('ct', 'Ciné Trend', { '2025': 2100000, '2026': 2100000 }, { '2025': 400000, '2026': 400000 }, [100, 60, 50, 33, 25]),
  new ProduitEcranEnsemble('cc', 'Ciné City', { '2025': 930000, '2026': 930000 }, { '2025': 204000, '2026': 175000 }, [100],
    [] // Normalement non commercialisé en fin d'année.
  ),
  new ProduitEcranEnsemble('cm', 'Ciné Mall', { '2025': 1050000, '2026': 1050000 }, { '2025': 245000, '2026': 200000 }, [100],
    [] // Normalement non commercialisé en fin d'année.
  )
];

export const produitsNumeriques = [
  new ProduitNumerique('fv', 'Full View', { '2025': 8700000, '2026': 8700000 }, { '2025': 63300, '2026': 63300 }),
  new ProduitNumerique('fvm', 'Full View Matinée', { '2025': 4350000, '2026': 4350000 }, { '2025': 40300, '2026': 40300 }),
  new ProduitNumerique('fvns', 'Full View Night Show', { '2025': 4350000, '2026': 4350000 }, { '2025': 40300, '2026': 40300 }),
  new ProduitNumerique('fvwd', 'Full View Weekday', { '2025': 3915000, '2026': 3915000 }, { '2025': 37000, '2026': 37000 }),
  new ProduitNumerique('fvwe', 'Full View Weekend', { '2025': 4785000, '2026': 4785000 }, { '2025': 45300, '2026': 45300 }),
  new ProduitNumerique('csi', 'Cinescreen IDF', { '2025': 1900000, '2026': 1900000 }, { '2025': 19500, '2026': 19500 }),
  new ProduitNumerique('csa', 'Cinescreen 15-24 ans', { '2025': 5000000, '2026': 5000000 }, { '2025': 45300, '2026': 45300 }),
  new ProduitNumerique('csu', 'Cinescreen CSP+', { '2025': 3700000, '2026': 3700000 }, { '2025': 35000, '2026': 35000 })
];

export const produitsEcransCibles = [
  uppers,
  generationAlpha,
  workingGirls,
  boomers
];
